const btnMob = document.querySelector('.mobile-nav-btn');
const navMobActive = document.querySelector('.nav-mobil-on');


btnMob.addEventListener('click',  function() {

  btnMob.classList.toggle('active');
  navMobActive.classList.toggle('active-nav-mob');


})